<template lang="pug">
.quick_menu(:class="{ expand: isExpand }")
  .menu_btns
    .btns(:class="{ expand: isExpand }")
      router-link.icon_btn(
        v-for="(link, index) in links",
        tag="a",
        :to="link.to || { name: link.linkName }",
        :key="index"
      )
        img(:src="link.icon")
        p {{ link.name }}
  .expand_btn.d-flex.flex-column.justify-content-center.align-items-center(
    @click="expand()",
    :class="{ expand: isExpand }"
  )
    svg-icon(iconClass="arrow_bottom_g")
    span 功能快捷
</template>

<script>
import CustomerImg from "@/assets/img/icon/q_customer.png";
import QAImg from "@/assets/img/icon/q_qa.png";
import LocationImg from "@/assets/img/icon/q_location.png";
import ContactImg from "@/assets/img/icon/q_contact.png";
import DownloadImg from "@/assets/img/icon/q_download.png";

export default {
  name: "QuickMenu",
  data() {
    return {
      isExpand: false,
      links: [
        {
          name: "客戶關懷",
          to: { name: "Customize", params: { page: "customercare" } },
          icon: CustomerImg,
        },
        {
          name: "聯絡我們",
          linkName: "CustomerServiceContactUs",
          icon: ContactImg,
        },
        { name: "常見問題", linkName: "CustomerServiceFAQ", icon: QAImg },
        {
          name: "下載文件",
          linkName: "CustomerServiceDocumentDownload",
          icon: DownloadImg,
        },
        { name: "服務據點", linkName: "Location", icon: LocationImg },
      ],
    };
  },
  methods: {
    expand() {
      this.isExpand = !this.isExpand;

    },
  },
};
</script>

<style lang="scss" scoped>
.quick_menu {
  position: relative; 
}

.quick_menu.expand {
  z-index: 9;
}

// .menu_btns {
//   height: auto;
//   width: auto;
//   overflow: hidden;
// }

// .btns {
//   height: auto;
//   width: auto;
//   transition: all 0.5s ease-in-out;
//   background: white;
//   transform: translateY(100%);
// }

// .btns.expand {
//   transform: translateY(0);
// }

.menu_btns {
  width: auto;
  overflow: hidden;
  background: transparent;
}

.btns {
  width: auto;
  max-height: 0;          
  overflow: hidden;        
  transition: max-height 0.5s ease-in-out;
  background: white;
}

.btns.expand {
  max-height: 500px;       
}

.icon_btn {
  display: block;
  text-align: center;
  padding-bottom: 20px;
  cursor: pointer;

  img {
    @include circle(50px, 50px);
  }

  p {
    color: $color_blue_btn_ci;
    font-size: 16px;
    font-size: 14px;
    margin: 0;
  }
  &:first-child {
    img {
      border-radius: 0px;
    }
  }
}

.expand_btn {
  background: $color_blue_quick_ci;
  @include size(67px, 66px);
  text-align: center;
  color: $color_white;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 1px 3px 3px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  svg {
    transform: rotate(180deg);
    transition: all 0.3s ease-in-out;
  }
}

.expand_btn.expand {
  svg {
    transform: rotate(0deg);
  }
}

@media (max-width: 991px) {
  .quick_menu {
    top: 186px;
  }

  .expand_btn {
    @include size(56px, 55px);
    font-size: 12px;
  }

  .icon_btn {
    img {
      @include circle(41.7px, 41.7px);
    }

    p {
      color: $color_blue_btn_ci;
      font-size: 14px;
      margin: 0;
    }
  }
}
</style>
